import React, { Component } from 'react'
import PropTypes from 'prop-types'
import JSONPretty from 'react-json-pretty';
import {Panel, Button} from 'react-bootstrap'

export default class GameInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
       open: false
    };
  }

  render () {


    return (

            <div>
              <Button bsStyle="info" block  onClick={ ()=> this.setState({ open: !this.state.open })}>
                Game Information
              </Button>
              <Panel collapsible expanded={this.state.open}>
                <JSONPretty id="json-pretty" json={this.props.gameInfo}></JSONPretty>

              </Panel>
            </div>

    )
  }

}

GameInformation.propTypes = {

  gameInfo: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/GameInformation.js